"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 2a.5.5 0 0 0-.5.5v8h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h8v8a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-8h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-8v-8A.5.5 0 0 0 13 2z",
        clipRule: "evenodd"
      }
    )
  }
), h = l(i);
export {
  h as PlusMedium,
  h as default
};
